import type { GalleryContent } from '@mawkaa/types';
import { ImageIcon } from 'lucide-react';

interface GalleryBlockProps {
  content: GalleryContent;
  isEditing?: boolean;
}

export function GalleryBlock({ content, isEditing }: GalleryBlockProps) {
  const { title, images = [], columns = 3 } = content;

  const gridCols = {
    2: 'grid-cols-2',
    3: 'grid-cols-2 md:grid-cols-3',
    4: 'grid-cols-2 md:grid-cols-4',
  };

  if (images.length === 0) {
    return (
      <section className="px-4 py-12">
        <div className="max-w-6xl mx-auto">
          {title && <h2 className="text-3xl font-bold text-center mb-8">{title}</h2>}
          <div className="grid grid-cols-3 gap-4">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="aspect-square bg-gray-100 rounded-lg flex items-center justify-center">
                <ImageIcon className="w-8 h-8 text-gray-400" />
              </div>
            ))}
          </div>
          {isEditing && (
            <p className="text-center text-muted-foreground mt-4">
              Cliquez pour ajouter des images à la galerie
            </p>
          )}
        </div>
      </section>
    );
  }

  return (
    <section className="px-4 py-12">
      <div className="max-w-6xl mx-auto">
        {title && <h2 className="text-3xl font-bold text-center mb-8">{title}</h2>}
        <div className={`grid ${gridCols[columns as keyof typeof gridCols] || gridCols[3]} gap-4`}>
          {images.map((image, index) => (
            <div key={index} className="aspect-square overflow-hidden rounded-lg">
              <img
                src={image.src}
                alt={image.alt || `Image ${index + 1}`}
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
